import { Customer } from './customer.model';

export interface CustomerDuplicateGroupPaginatedModel {
  type: CustomerDuplicateTypeModel;
  duplicateKey: string;
  sortDate: string;
  records: number;
  recordsList: CustomerDuplicateRecordModel[];
  priority?: CustomerDuplicatePriorityModel | null;
}

export interface CustomerDuplicateGroupDetailModel {
  type: CustomerDuplicateTypeModel;
  duplicateKey: string;
  recordsList: CustomerDuplicateRecordModel[];
}

export interface CustomerDuplicateRecordModel {
  customerID: string;
  name: string;
  phone: string;
  email?: string | null;
  createdDate: string;
  quotes?: number;
}

export interface CustomerDuplicateBatchResponseModel {
  items: CustomerDuplicateBatchItemModel[];
  totals: CustomerDuplicateBatchTotalsModel;
}

export interface CustomerDuplicateBatchTotalsModel {
  quotes: number;
  enrolledProducts: number;
  familyMembers: number;
  documents: number;
  notes: number;
}

export interface CustomerDuplicateBatchItemModel {
  customer: Customer;
  quotes: number;
  enrolledProducts: number;
  familyMembers: number;
  documents: number;
  notes: number;
}

export enum CustomerDuplicateTypeModel {
  PhoneExact = 1,
  FullNameExact = 2,
}

export enum CustomerDuplicatePriorityModel {
  High = 1,
  Medium = 2,
  Low = 3,
}
